<template>
  <div class="error">
      <img src="@/assets/images/404.png" alt="">
      <div class="error-cen">
        <div class="err-tip">抱歉！您访问的页面出错了</div>
        <div>
            <el-button type="primary" @click="goHome">返回首页</el-button>
        </div>
      </div>
  </div>
</template>

<script>
export default {

    methods: {
        goHome() {
            this.$router.push('/') 
        }
    }
}
</script>

<style scoped lang="scss">
    .error{
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        // justify-content: center;
        
        img{
            height: 500px;
        }
        .error-cen{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            line-height: 80px;
        }
        .err-tip{
            font-size: 34px;
        }
    }

</style>